
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
//import Checkbox from "@material-ui/core/Checkbox";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";


import * as notif from "components/Notification/notification"

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";



import {  useHistory, useRouteMatch } from "react-router-dom";
import { loadDeviceAction, deleteDeviceAction} from "action/deviceAction";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";


//import product1 from "assets/img/product1.jpg";

const useStyles = makeStyles(styles);
const useStyleAlert = makeStyles(stylesAlert)


const Device = (props) => 
{
  const actualURL = useRouteMatch();
  const [tableData, setTableData] = useState([]);
  const history = useNavigate();
  const {loadDeviceFromSaga, deviceLoadDispatch, deviceDeleteDispatch} = props;
  const [alert, setAlert] = React.useState(null);
  const [deleteStatut, setDeleteStatut] = React.useState(false);

  const dispatchRefreshTable = useCallback(() => {
    deviceLoadDispatch()
  }, [deviceLoadDispatch])


  const loadCardFromSagaUnique = useCallback(() => {
    return (loadDeviceFromSaga)
  }, [loadDeviceFromSaga])


  useEffect(() => {
    dispatchRefreshTable()
  },[dispatchRefreshTable])


  useEffect(() => 
  {
    if (deleteStatut === true)
    {
      if (loadDeviceFromSaga.loading === false)
        {
          let msg;
            let title;
          if (loadDeviceFromSaga.error.length > 0)
          {
  
            title = "Echeque Supression Device"
              msg = "La Device n a pas ete suprime";
            notif.showFailedNotification(title, msg)
            
          }
          else
          {
            title = "Supression Device"
              msg = "La Device   a ete suprimer";
            notif.showSuccessNotification(title, msg)
            setAlert(
              <SweetAlert
                success
                style={{ display: "block", marginTop: "-100px" }}
                title="Suprimer!"
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
              >
                Cette article a ete supprimer.
              </SweetAlert>
            );
          }
          setDeleteStatut(false);
        }
    }

  }, [deleteStatut, loadDeviceFromSaga])
  

  const handleRefresh = () => {
    deviceLoadDispatch()
  }


  const successDelete = (id) => {
    
    const data = 
    {
      'numeroDeSerieDevice' : id
    }

    deviceDeleteDispatch(data);
    setDeleteStatut(true)
    /*
    
    */
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Annuler"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
      >
        Votre article n a pas ete supprimer
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };




/*
active: true
dateReceptiondevice: "2020-11-11T00:00:00.000+00:00"
etatdevice: "new"
identifiantdevice: 8
numerodevice: "778188858"
numeroDeCommandedevice: "command"
numeroDeSeriedevice: "444433"
*/

const warningWithConfirmAndCancelMessage = (id) => {
  setAlert(
    <SweetAlert
      warning
      style={{ display: "block", marginTop: "-100px" }}
      title="Etes vous sure ?"
      onConfirm={() => successDelete(id)}
      onCancel={() => cancelDetele()}
      confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
      cancelBtnCssClass={classesAlert.button + " " + classesAlert.danger}
      confirmBtnText="Suprimer!"
      cancelBtnText="Annuler"
      showCancel
    >
      Vous ne pourez pas recuperer cette article!
    </SweetAlert>
  );
};


const classes = useStyles();
const classesAlert = useStyleAlert();

const handleButDelete = (id) => 
{
  warningWithConfirmAndCancelMessage(id);
 // console.log("CLIKKKKKK DELETE " + id)
}

const handleButUpdate = (id) => {
 // console.log("CLIKKKKKK UPDATE " + id)

  history(`${actualURL.url}/${id}/edit`)

}

const handleButShowDetail = (id) => {
//  console.log("CLIKKKKKK DETAIL "  + id)
}
 

const roundButtons = (id) => 
{
  const tabRound = [
  { color: "success", icon: Edit , onClick: handleButUpdate},
  { color: "danger", icon: Close, onClick: handleButDelete }
].map((prop, key) => {
  return (
    <Button
      round
      color={prop.color}
      className={classes.actionButton + " " + classes.actionButtonRound}
      key={key}
      onClick={() => {prop.onClick(id)}}

    >
      <prop.icon className={classes.icon} />
    </Button>
  );
});
return tabRound
}

/*
modeleDevice: "HQ"
numeroDevice: "7801059466"
dateReception: "2020-12-01"
dureeValidite: "2020-12-08"
enMarche: true
identifiantDevice: 1
isActive: "true"
latitude: "14.74328"
longitude: "-17.511356666666668"

*/


const statusDatePayement = (date, etat) => {
  
  if(etat === "DANGER")
  {
    return (
      <img
          src={require('assets/img/emergencylevel/carre_rouge.png')}
          alt={'expirer'}
        /> 
    )
  }
  else if(etat === "WARNING")
  {
    return (
      <img
          src={require('assets/img/emergencylevel/carre_orange.png')}
          alt={'URGENT'}
        /> 
    )
  }
  else if(etat === "SUCCESS")
  {
    return (
      <img
          src={require('assets/img/emergencylevel/carre_vert.png')}
          alt={'Danns les temps'}
        /> 
    )
  }

  
}

useEffect(() => 
{
  
  const activeStr = (active) => 
  {
    return (active ? "active" : "desactive")
  }
 const tabLoad = loadDeviceFromSaga.devices;

 let table = [];
 let cnt = 0;
 if (tabLoad !== undefined)
 {
   table = tabLoad.map((row) => 
  {
    cnt++;
     let numeroTel = ""
     if (row.sim !== undefined)
     {
       numeroTel = row.sim.numeroCarteSim
     }
    return(
      [
        cnt, statusDatePayement(row.dureeValidite, row.etatDevices),
        row.modeleDevice,  row.numeroDevice, row.dateReception, numeroTel, row.dureeValidite, row.vehiculeName, row.clientName , roundButtons(row.identifiantDevice)
      ]
    )
     
  }
  )
  setTableData(table)
 }

}, [loadCardFromSagaUnique])


 

  return (
    <GridContainer>
      {alert}
      <GridItem xs={12}>
      <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={()=>{handleRefresh()}} disabled={false}>
             Refresh List
          </Button>
          <Button className="mr-2" color="info" onClick={()=>{ history(`${actualURL.url}/new`) }} disabled={false}>
             Ajouter device
          </Button>
          
        </div>
        <Card>
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>device</h4>
          </CardHeader>
          <CardBody>
            <Table
              tableHead={[
                "#",
                "Modele",
                "Etat",
                "Numero",
                "Date Reception",
                "Numero Sim",
                "Expiration",
                "Vehicule",
                "client",
                
                "Action",
              ]}
              tableData={tableData}
              customCellClasses={[classes.center, classes.right, classes.right]}
              customClassesForCells={[0, 4, 5]}
              customHeadCellClasses={[
                classes.center,
                classes.right,
                classes.right
              ]}
              customHeadClassesForCells={[0, 4, 5]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>

  )
}


const mapStateToProps = (state) => {
 // console.log('state', state.devices)
  return (
    {
      loadDeviceFromSaga : state.devices
    }
  )
}

const mapsDispatchToProps = dispatch => {
  return (
    {
      deviceLoadDispatch: () => {dispatch(loadDeviceAction())},
      deviceDeleteDispatch: (data) => {dispatch(deleteDeviceAction(data))},      
  })
}

export default connect(mapStateToProps, mapsDispatchToProps)(Device);